import { Navigate } from "react-router-dom";
import Navbar from "../../../components/Navbar/Navbar";
import { useDoesUserHaveRole } from "../../../hooks/permissions";
import { UserRole } from "../../../utils/types/user";
import UserListsWrapper from "../components/UserListsWrapper/UserListsWrapper";

export default function UsersManagementPage() {
    const canAccessUserManagement = useDoesUserHaveRole([
        UserRole.SUPER_ADMIN,
        UserRole.BILLER_ADMIN,
        UserRole.SUPPORT_ADMIN,
        UserRole.SUPPORT_GENERAL,
    ]);

    if (!canAccessUserManagement) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Navbar title="User Management" />
            <div className="page">
                <UserListsWrapper />
            </div>
        </>
    );
}
